// extracted by mini-css-extract-plugin
export default {"header-btn":"PrintComparisonBtn_header-btn__jqZit"};